import React from "react";
import { Pagination, Stack, Typography } from "@mui/material";

interface PaginationProps {
  page: number;
  totalItems: number;
  itemsPerPage?: number;
  onChange: (page: number) => void;
}

const Paginations: React.FC<PaginationProps> = ({
  page,
  totalItems,
  itemsPerPage = 10,
  onChange,
}) => {
  const totalPages = Math.max(
    1,
    Math.ceil(totalItems / itemsPerPage)
  );

  if (totalPages <= 1) return null;

  return (
    <Stack spacing={1.5} alignItems="center" mt={4}>
      <Pagination
        count={totalPages}
        page={page}
        onChange={(_, value) => onChange(value)}
        color="primary"
        shape="rounded"
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
      />

      <Typography variant="caption" color="text.secondary">
        Page {page} of {totalPages}
      </Typography>
    </Stack>
  );
};

export default Paginations;
